export const processor = (original:any[][])=> {
  const expressions = []
  for (let i = 0, maxRows = original.length; i < maxRows; i++) {
    let row = []
    const originalRow = original[i]
    expressions.push(row)
    for (let j = 0, maxCols = originalRow.length; j < maxCols; j++) {
      let cell = originalRow[j];
      // ignore non-string
      if (typeof cell !== "string") continue
      if (cell.startsWith('=')) {
        row[j] = cell
      }
    }
  }

  return (data:any[][], refers:boolean[][]) => {
    for (let i = 0, maxRows = data.length; i < maxRows; i++) {
      if (refers[i] == null) refers[i] = []
      for (let j = 0, maxCols = data[i].length; j < maxCols; j++) {
        let expr = expressions[i][j]
        if (!expr) continue
        data[i][j] = expressions[i][j]
      }
    }
    return data
  }
}


// WEBPACK FOOTER //
// ./src/widgets/spread_sheet/spread-sheet/preprocessors/expression.ts